export default "__VITE_ASSET__CM8inMy8__"